// third-party
import { generate } from '@ant-design/colors';

// ==============================|| PRESET THEME - NEXTGEN GTN BRAND ||============================== //

// Brand colors (client-provided):
//   navy  #092C54 — primary brand color (wordmark)
//   teal  #04797E — secondary accent ("GTN")
//   green #7FAD52 — success / positive accent
const BRAND_NAVY = '#092C54';
const BRAND_TEAL = '#04797E';
const BRAND_GREEN = '#7FAD52';

export default function Default(colors) {
  const { red, gold, grey } = colors;

  // 10-step ramps generated from the brand colors (base sits at index 5)
  const navy = generate(BRAND_NAVY);
  const teal = generate(BRAND_TEAL);
  const green = generate(BRAND_GREEN);

  const greyColors = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16]
  };
  const contrastText = '#fff';

  return {
    primary: {
      lighter: navy[0],
      100: navy[1],
      200: navy[2],
      light: navy[3],
      400: navy[4],
      main: BRAND_NAVY,
      dark: navy[6],
      700: navy[7],
      darker: navy[8],
      900: navy[9],
      contrastText
    },
    secondary: {
      lighter: greyColors[100],
      100: greyColors[100],
      200: greyColors[200],
      light: greyColors[300],
      400: greyColors[400],
      main: greyColors[500],
      600: greyColors[600],
      dark: greyColors[700],
      800: greyColors[800],
      darker: greyColors[900],
      A100: greyColors[0],
      A200: greyColors.A400,
      A300: greyColors.A700,
      contrastText: greyColors[0]
    },
    error: {
      lighter: red[0],
      light: red[2],
      main: red[4],
      dark: red[7],
      darker: red[9],
      contrastText
    },
    warning: {
      lighter: gold[0],
      light: gold[3],
      main: gold[5],
      dark: gold[7],
      darker: gold[9],
      contrastText: greyColors[100]
    },
    info: {
      lighter: teal[0],
      light: teal[3],
      main: BRAND_TEAL,
      dark: teal[7],
      darker: teal[9],
      contrastText
    },
    success: {
      lighter: green[0],
      light: green[3],
      main: BRAND_GREEN,
      dark: green[7],
      darker: green[9],
      contrastText
    },
    grey: greyColors
  };
}
